import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Event from '../../components/Events/Event'
import client from '../../Services/client'


class EventList extends Component {
    state = {
        content_events: [],
        searchString: ''
    }
    constructor() {
        super()
        this.getNews()
    }
    getNews = () => {
        client.getEntries({
                content_type: 'events',
                query: this.state.searchString
            })
            .then((response) => {
                this.setState({
                    content_events: response.items
                })
                console.log(this.state.content_events)
            })
            .catch((error) => {
                console.log("Error occurred while fetching Entries")
                console.error(error)
            })
    }
    onSearchInputChange = (event) => {
        console.log("Search changed ..." + event.target.value)
        if (event.target.value) {
            this.setState({
                searchString: event.target.value
            })
        } else {
            this.setState({
                searchString: ''
            })
        }
        this.getNews()
    }
    render() {
        return (
            <main className="listing-page">
                { this.state.content_events ? (
                    <div>
                        <div className="listing-header">
                            <div>
                                <span className="listing-eyebrow">Selected portfolio</span>
                                <h1>Projects</h1>
                            </div>
                        <TextField className="listing-search"
                            id="searchInput"
                            placeholder="Search for Projects"   
                            margin="normal"
                            onChange={this.onSearchInputChange}
                            />
                        </div>
                        <Grid container spacing={3} className="listing-grid">
                            { this.state.content_events.map(currentNews => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={currentNews.sys.id}>
                                    <Event events={currentNews} />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ) : "No Events found" }
            </main>
        )
    }
}
export default EventList;


// WEBPACK FOOTER //
// ./src/components/Events/EventList.js